<template>
  <div class="container">
    <BreadCrumbs :links="[{ to: 'touchBord', name: 'touchbord.Portrait' }]" />
  </div>

  <div class="main" :class="{ dark: darkStyle }">
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="intro_titleTop">
              <div class="intro_item">
                <h2 class="section__title">
                  {{ $t('touchbord.title') }}
                </h2>

                <button class="switch_btn" @click="pageStyle()">
                  <span v-if="!darkStyle">{{ $t('touchbord.darkStyle') }}</span>
                  <span v-if="darkStyle">{{ $t('touchbord.lightStyle') }}</span>
                </button>
              </div>
              <div class="section__subTitle">
                {{ $t('touchbord.discription') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="intro_titleBottom">
              <div class="touchBord-date">
                <div class="touchBord-select">
                  {{ $t(denIsActive) }}
                  <SvgIcon name="triangle-down" />
                </div>
                <div class="touchBord-option">
                  <button @click="changeDate(dateDay)">
                    {{ $t(dateDay) }}
                  </button>
                  <button @click="changeDate(dateWeek)">
                    {{ $t(dateWeek) }}
                  </button>
                  <button @click="changeDate(dateMes)">
                    {{ $t(dateMes) }}
                  </button>
                  <button @click="changeDate('quaterTitle')">
                    {{ $t('quaterTitle') }}
                  </button>
                  <!-- <button @click="changeDate('period')">
                    {{ $t('period') }}
                  </button> -->
                  <button @click="changeDate(dateYear)">
                    {{ $t(dateYear) }}
                  </button>
                </div>
              </div>
              <div v-if="denIsActive === 'quaterTitle'" class="touchBord-date">
                <div class="touchBord-select">
                  {{ $t('quater', [quater + 1]) }}
                  <SvgIcon name="triangle-down" />
                </div>
                <div class="touchBord-option">
                  <button @click="quater = 0">
                    {{ $t('quater', [1]) }}
                  </button>
                  <button @click="quater = 1">
                    {{ $t('quater', [2]) }}
                  </button>
                  <button @click="quater = 2">
                    {{ $t('quater', [3]) }}
                  </button>
                  <button @click="quater = 3">
                    {{ $t('quater', [4]) }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section" style="margin-bottom: 15px">
      <div class="container">
        <div class="row">
          <div class="col">
            <h2 class="task-name12" style="margin: 0">
              <p>{{ $t('touchbord.hintTitle') }}</p>
              <button class="hint" type="button">
                <SvgIcon name="questionMark" />

                <div class="hint-content">
                  {{ $t('touchbord.hintDescription') }}
                </div>
              </button>
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col">
            <div id="chartdiv" class="chartdiv">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 950 650"
                @mouseover="mouseover"
                @mouseout="hoveredRegion = null"
              >
                <path
                  d="m 109.03,193.35 -2.87,1.21 -2.72,-3.76 -2.57,3.76 0.46,5.13 -3.48,1.21 -5.44,4.08 -4.08,0.46 -4.07,5.13 -7.1,-1.51 -3.18,4.83 2.42,1.82 v 4.53 h -5.29 l -8,8.31 -3.93,-2.12 h -2.11 l 4.22,17.83 2.42,1.51 -1.06,4.98 -8.3,4.99 -4.84,-1.36 -13.44,-22.06 -3.17,0.46 -4.69,4.83 -0.45,4.83 1.36,1.06 v 3.02 l -4.53,5.14 -5.14,1.51 -1.06,1.96 v 7.56 h -1.96 v 9.36 l 5.74,4.99 -1.21,5.74 -4.83,3.32 -2.87,8.46 -3.32,9.21 13.89,5.89 6.2,1.97 h 12.23 l 2.27,1.81 8.31,1.66 h 8.45 l 7.86,3.93 6.95,1.96 2.42,-4.38 h 11.17 l 2.72,-6.19 23.27,-15.86 8.3,-1.96 7.56,3.32 -1.36,3.02 9.51,0.45 3.33,2.72 4.83,-0.75 0.45,-6.2 3.48,-1.96 -0.61,-8.01 3.78,-3.02 11.33,1.06 6.19,-6.19 1.36,-9.82 3.63,-4.53 9.06,0.9 6.04,-5.74 -1.66,-12.08 -1.81,-7.56 4.53,-7.85 -3.32,-2.42 2.26,-9.06 -7.7,-3.17 v -3.93 l -5.74,-4.08 -5.29,-1.21 -1.36,-6.8 -7.25,-3.62 -15.91,1.62 -5.92,-9.7 -12.49,4.94 -0.23,4.39 -2.01,0.93 -2.24,-3.12 -1.86,1.86 -4.62,0.33 -1.67,-2.19 3.11,-2.89 -3.23,-2.88 -3.6,1.44 -6.12,-3.95 z"
                  :fill="getRegionFillColor('KZ-ZAP')"
                  stroke="#D3D3D3"
                  id="KZ-ZAP"
                ></path>
                <path
                  d="m 29.09,312.06 13.34,-1.01 2.67,2.04 7.62,1.44 8.56,0.5 14.9,5.96 2.68,-4.4 h 10.9 l 2.89,-6.64 23.04,-15.59 8.64,-2.05 7.2,3.29 -1.44,2.88 10.09,1.03 3.08,2.88 5.15,-1.24 v -6.17 l 3.49,-1.85 -0.61,-8.23 3.9,-3.09 10.91,1.44 6.59,-6.38 8.43,1.65 v 13.79 l 11.73,4.52 3.7,-6.58 5.77,4.11 -0.62,4.12 0.62,10.7 -0.62,7.41 4.73,3.49 -1.44,10.7 -1.65,9.67 v 7.97 l 6.59,10.55 5.35,5.56 18.52,7.2 -0.62,4.53 3.29,4.11 v 4.53 h -5.55 l -8.23,-10.29 h -4.12 l -4.11,-3.91 -4.53,4.94 -11.32,0.62 -5.76,2.45 -13.17,1.66 -4.73,9.26 -4.94,4.53 -7.61,1.23 -1.65,2.88 -4.73,-8.64 2.26,-7.61 3.09,-10.29 -10.08,-16.25 -6.18,-2.89 -4.11,-1.02 -2.47,2.67 -5.97,-0.62 -3.29,3.5 h -11.52 l -4.53,-2.88 -24.9,16.46 -1.85,7 -13.27,1.01 -17,-9.84 -1.4,-3.87 3.24,-3.69 3.24,3.94 3.43,0.51 2.6,-2.54 -8.32,-14.8 -12.19,-20.69 -16.63,-1.66 -1.08,4.26 -4.89,-3.94 0.13,-7.3 -0.13,-4.06 -1.9,-5.08 z"
                  :fill="getRegionFillColor('KZ-ATY')"
                  stroke="#D3D3D3"
                  id="KZ-ATY"
                ></path>
                <path
                  d="m 162.06,395.32 7.91,-1.44 5.28,-4.31 4.56,-9.84 12.95,-1.43 5.99,-2.16 11.27,-0.96 4.56,-4.56 4.31,3.84 h 3.6 l 8.87,10.31 h 5.11 l 4.73,17.27 1.44,15.58 -16.07,7.2 v 128.54 l -10.07,2.15 -8.16,-6.47 -6.47,-12.23 0.72,-3.84 -3.12,-4.08 -15.11,-12.47 -23.98,6.72 -5.51,5.04 -8.16,5.75 -2.16,-10.79 2.88,-2.88 4.56,-11.99 -2.88,-8.87 -13.19,-1.68 -2.16,1.68 -6.23,-12.23 -4.08,1.44 h -3.84 l -0.72,-11.99 -9.11,-17.75 -3.84,-9.83 h -5.75 l -4.68,-1.68 -1.32,-7.43 4.32,-2.4 h 10.79 l 3.6,5.03 h 5.03 l 8.88,-1.2 -4.08,-4.55 h -3.84 l -5.99,-11.51 5.03,-2.4 v -6.48 l 3.36,-3.59 h 3.84 l 4.25,-3.84 7.5,2.16 h 11.51 l 7.43,2.88 h 21.11 v 4.31 l -3.12,4.56 -3.84,1.2 -12.23,24.94 1.2,3.6 3.12,-2.64 5.04,-7.44 3.59,-10.79 3.9,-6.47 h 5.22 l 3.35,-4.32 9.6,-1.92 -2.64,-7.91 -6.96,-12.88 -4.79,1.13 -3.12,-1.13 -3.84,2.33 2.4,6.95 -1.44,3.6 -7.91,-2.16 -5.52,-2.64 1.44,-8.08 z"
                  :fill="getRegionFillColor('KZ-MAN')"
                  stroke="#D3D3D3"
                  id="KZ-MAN"
                ></path>
                <path
                  d="m 242.64,417.55 -1.47,-15.54 -4.7,-17.18 v -4.6 l -3.27,-4.14 0.5,-4.47 -18.44,-7.13 -5.4,-5.66 -6.63,-10.6 0.13,-8.18 2.99,-20.01 -4.64,-3.55 0.55,-7.64 -0.55,-10.81 0.55,-3.67 -5.71,-4 -3.79,6.37 -11.65,-4.44 v -13.76 l -8.57,-1.67 1.48,-9.64 3.5,-4.6 9.12,0.84 5.77,-5.74 -1.6,-11.82 -1.73,-7.85 4.43,-7.51 3.04,-2.83 0.17,-9.25 -4.08,-4.32 3.91,-1.96 7.31,4.24 15.49,12.7 8.79,-6.84 0.98,-4.56 13.52,-6.51 10.91,-1.31 3.91,6.52 h 8.79 v -7.82 l 9.45,3.58 5.21,-2.28 3.59,2.28 1.62,7.82 6.84,4.56 10.75,1.31 9.45,3.25 3.26,-7.81 4.88,-1.31 3.59,5.87 h 11.72 l 13.68,-5.87 4.89,-18.24 h 5.21 l 0.98,5.21 2.6,1.63 h 4.89 v 5.54 l 5.86,3.58 -5.86,2.28 v 5.87 h 5.86 v 6.18 l 9.78,14.79 v 5.74 h -6.84 l -5.54,10.42 v 12.7 l 9.77,12.38 5.54,-1.3 1.3,3.58 v 4.56 l 14.66,7.17 11.4,21.17 -30.29,24.76 -6.84,-3.26 -8.8,-10.75 -6.51,-10.75 -14.01,2.28 -9.77,25.08 -9.77,-1.3 v 7.82 h -5.87 l -11.4,9.44 -11.73,18.89 -5.86,2.94 1.96,23.77 -11.4,-8.79 -40.72,13.68 z"
                  :fill="getRegionFillColor('KZ-AKT')"
                  stroke="#D3D3D3"
                  id="KZ-AKT"
                ></path>
                <path
                  d="M 377.56,344.02 362.04,323 l -13.54,2.71 -10.19,24.68 -9.23,-1.27 v 7.64 l -6.06,0.48 -11.94,10.03 -11.46,18.31 -5.42,3.03 1.28,23.89 20.54,11.46 10.03,7.33 13.53,14.01 23.01,30.89 h 9.24 l 6.84,-1.91 6.37,-1.59 4.46,-1.28 10.99,1.28 10.83,1.59 10.19,-0.64 7.16,-4.62 h 4.3 l 2.07,7.17 9.56,6.53 5.89,16.08 3.18,-1.75 h 2.55 v 20.38 l 2.87,0.64 37.9,-30.1 -4.78,-6.05 5.89,-11.62 3.03,-12.26 -13.06,-11.15 0.79,-27.55 -6.84,-3.98 -0.64,-3.5 3.5,-13.86 -2.86,-6.84 -1.23,-7.33 -33.49,-1.43 -13.85,-9.87 -29.78,-13.7 -15.6,-7.96 -2.23,1.43 -8.28,0.8 7.01,-4.78 z"
                  :fill="getRegionFillColor('KZ-KZY')"
                  stroke="#D3D3D3"
                  id="KZ-KZY"
                ></path>
                <path
                  d="m 481.69,389.94 3.18,7.99 -3.49,14.03 0.86,3.41 6.66,4.26 -0.62,27.37 12.85,11.16 -2.77,11.71 -6.2,11.86 4.73,6.12 -37.76,30.22 -3.02,-1.07 -2.32,-0.54 v 14.49 l 11.47,2.79 5.89,25.43 25.04,-1.55 6.51,4.65 v 3.72 l -3.02,4.96 15.35,8.22 -2.02,-11.4 3.64,-2.94 6.98,-11.63 19.3,-14.11 16.75,-10.54 6.66,-10.48 -15.11,-15.34 -5.04,-15.89 -10.08,-2.71 -3.87,-6.59 3.87,-3.1 5.43,-21.32 -2.33,-22.48 -13.95,-40.7 h -42.25 z"
                  :fill="getRegionFillColor('KZ-YUZ')"
                  stroke="#D3D3D3"
                  id="KZ-YUZ"
                ></path>
                <path
                  d="m 525.17,389.94 14.12,40.74 2.26,22.41 -5.59,21.44 -3.73,3.02 3.94,6.48 10.03,2.62 5.06,16.06 15.08,15.27 v -0.67 l 3.44,-8.9 6.85,-7.88 11.64,-1.03 9.93,3.43 13.7,6.85 13.36,3.42 2.05,-20.21 15.41,-6.5 12.33,7.53 4.45,1.03 15.07,5.48 4.11,-4.45 -13.36,-13.7 2.74,-5.14 -8.56,-6.16 5.82,-6.85 1.03,-10.28 -5.82,-6.16 h -5.48 l -5.82,-4.8 v -7.53 l -9.25,-6.85 -2.4,-8.9 h -7.19 l -1.02,-6.51 h 8.21 l -3.08,-10.62 3.08,-13.81 -111.64,1.17 z"
                  :fill="getRegionFillColor('KZ-ZHA')"
                  stroke="#D3D3D3"
                  id="KZ-ZHA"
                ></path>
                <path
                  d="m 685.27132,399.84336 0.055,2.73566 2.09926,6.58252 2.54151,2.17509 1.9538,3.6062 2.21445,8.79815 3.73978,0.63296 3.01148,5.0202 -0.9051,1.51266 0.15989,2.8824 2.3592,6.68262 3.76101,3.63915 1.63551,0.72683 -0.20428,1.91116 1.01097,1.43612 1.28093,-0.17316 2.26667,0.60009 0.28592,2.12082 -1.08888,1.95607 0.2795,2.20602 5.18097,2.34463 0.76252,1.60733 2.56178,-0.99523 2.4937,2.21945 -1.55807,2.47252 1.46516,0.54845 0.37168,2.02055 8.62334,-1.43797 8.75401,2.35371 11.93294,-0.11237 8.12882,-4.47382 2.85468,0.0996 5.60431,4.73539 7.41063,1.91576 8.26373,-1.38382 -3.48911,-7.67238 0.77636,-11.16232 -0.77636,-11.6747 -5.14607,-4.99342 h -3.59329 l -2.06043,-5.91774 3.85211,-3.62704 h 7.72404 l 6.17131,-4.15948 17.74745,-4.14946 5.3949,-3.1146 6.94773,7.26406 6.17125,-2.59217 4.88729,2.59217 0.77638,-8.04772 -9.00812,-7.01287 v -4.14944 l -13.62658,-23.882 1.28401,-3.89827 -5.14608,1.29608 -26.4868,-10.90112 v -3.63705 l -7.46524,-1.03483 -8.9982,3.63705 -8.23168,-9.35387 h -8.74933 l -2.05044,-2.3309 -10.29213,-4.93316 -2.56806,3.63704 -3.08568,-2.8634 -3.60321,2.8634 -4.88726,-1.04488 -3.08566,2.341 2.30925,18.17519 -8.22175,2.33091 -3.86204,-3.88822 -10.79978,1.55731 -7.4016,-0.54826 -0.77249,7.18551 z"
                  :fill="getRegionFillColor('KZ-JET')"
                  stroke="#D3D3D3"
                  id="KZ-JET"
                ></path>
                <path
                  d="m 634.50591,402.18546 2.8131,10.72556 h -8.03173 l 1.32203,6.23256 6.7097,0.23857 2.33597,8.74742 9.07548,6.88862 0.35767,7.61427 5.57648,4.49301 5.50692,0.17884 5.75543,6.17293 -1.04372,10.23851 -5.54669,6.60034 8.15106,6.22259 -2.60437,5.09937 13.26033,13.55856 13.88656,1.79919 5.90452,-0.77536 3.85685,-2.56457 7.96216,2.56457 13.34979,0.77536 h 14.38358 l 4.88071,3.08147 11.30209,2.05764 7.7037,9.50294 h 5.65602 l 8.98602,8.47902 h 3.33992 l -3.33992,-13.87663 2.57452,-7.18682 6.16299,-1.29224 -2.05765,-3.08146 -0.76541,-2.82306 2.82306,-1.7992 5.64606,-1.54073 V 483.805 l -3.08146,-0.6759 2.31611,-5.39758 -5.01723,-10.90784 -8.12251,1.3618 -7.54897,-1.88359 -5.42692,-4.57951 -2.81932,-0.27614 -8.22136,4.36664 -11.86638,0.22315 -8.95277,-2.30375 -8.47854,1.43275 -0.40628,-1.97627 -1.49418,-0.55675 1.5853,-2.45795 -2.43553,-2.18922 -2.52495,0.94175 -0.89172,-1.59711 -5.07248,-2.27634 -0.30807,-2.15376 1.05783,-1.89131 -0.32271,-2.20636 -2.2382,-0.57417 -1.22872,0.20626 -1.05078,-1.43487 0.21678,-1.95514 -1.48273,-0.58681 -3.90133,-3.64046 -2.37071,-6.6441 -0.14765,-2.80341 0.93679,-1.54129 -3.07752,-4.99859 -3.67914,-0.64382 -2.17159,-8.52176 -1.95911,-3.67922 -2.60064,-2.13914 -2.08582,-6.48038 -0.10818,-29.1578 0.72808,-7.03904 -2.99627,-3.28111 -13.98292,0.31672 -10.27823,6.42142 h -4.62222 l -16.44124,17.9621 z"
                  :fill="getRegionFillColor('KZ-ALM')"
                  stroke="#D3D3D3"
                  id="KZ-ALM"
                ></path>
                <path
                  d="m 803.41426,221.80581 1.77929,0.0424 5.57575,-1.58161 18.69365,0.38312 2.49248,-4.34546 4.26039,0.9679 3.79672,-3.37759 6.39543,0.55458 9.82504,4.30512 8.40486,11.41314 2.45388,10.99972 6.50168,0.98809 8.55947,5.05123 1.58435,9.01354 3.24603,7.1181 14.42358,2.48027 7.12968,-2.48027 7.53542,-8.85224 h 2.37653 l 1.42982,1.48211 0.23188,3.89176 -3.56487,4.30513 4.83042,0.32276 1.03372,4.63783 4.03818,6.94671 h 5.46804 l -0.23188,4.13373 -9.91198,-0.25188 -2.2896,3.81113 0.62797,9.50758 -4.99466,8.51954 -4.51156,0.33267 -3.48757,2.39959 -9.27437,0.49405 -5.54529,12.15922 v 2.81298 l 1.66168,0.82674 -0.7922,7.69279 1.82588,1.40143 -0.31876,8.18682 1.50709,0.99812 -0.71492,8.10616 -1.90316,5.29319 -7.92187,0.24198 -4.04785,4.97059 -6.26021,3.22635 -0.55065,-5.95866 h -11.10025 l -2.92723,1.32077 -8.48218,-2.97427 -10.7718,-6.78536 2.48254,-5.23458 -6.52821,-6.98766 1.97344,-11.02107 5.48162,-3.0456 2.03028,-8.03483 1.79744,-3.0786 1.33455,-0.69952 0.0646,-1.72534 -3.72339,-2.76746 -0.80819,-2.57371 -3.20243,-0.26939 -4.18906,-7.54631 1.02936,-5.53692 -2.53665,-1.12189 -4.13316,0.91195 -1.98811,-5.9288 1.17671,-1.7657 0.0803,-2.42751 -3.04326,-0.12118 -2.53588,-3.47865 -2.18097,-0.33381 -1.14462,0.66801 -1.12684,-1.30061 -4.99245,-2.22411 -1.95354,-3.89488 -2.55424,-2.56413 -2.04741,-0.91003 -2.21766,-5.76898 0.68705,-1.17795 -0.7726,-1.9846 -1.70535,-0.55212 -6.07773,-2.74597 0.69691,-5.12977 -5.09455,-2.6274 10e-4,-1.57005 1.40252,-0.91486 3.88045,0.91314 0.26145,-0.78018 -1.50491,-2.19816 0.55913,-0.8372 2.76943,0.0923 2.80199,2.12249 1.58533,-1.28944 0.61038,-3.0317 -0.86437,-1.81142 1.06453,-1.90944 -0.91023,-5.38754 -2.20412,-3.76578 z"
                  :fill="getRegionFillColor('KZ-VOS')"
                  stroke="#D3D3D3"
                  id="KZ-VOS"
                ></path>
                <path
                  d="m 818.07286,404.13711 v -3.8615 l -13.23528,-24.23782 1.11099,-3.56913 -4.43432,1.35101 -26.00684,-11.49381 v -3.13557 l -7.40017,-1.11916 -8.42422,3.57922 -8.41456,-9.55802 h -7.93153 l -2.31858,-2.31891 -9.98926,-4.44628 -2.31857,3.18599 -3.13974,-2.60122 -3.14942,2.60122 -5.18786,-0.76624 -2.67603,2.51048 -4.54059,-1.2603 -2.40556,3.49855 -7.68031,-6.30141 2.13502,-5.98889 3.60349,-0.76624 -0.28006,-14.87138 2.50214,-0.58477 4.81111,-6.80555 -7.58373,-4.58742 -1.75827,-3.18604 -2.50217,-3.18598 0.83085,-4.09342 7.40983,-0.33267 2.12536,-11.89708 -10.36604,-0.6755 0.28006,-5.98891 5.2748,-0.67551 -2.58908,-2.60125 -7.59341,-6.57365 -0.74388,-5.69647 9.63184,-2.89364 3.98023,-4.44628 -0.84049,-3.09525 -0.36712,-4.34549 2.12539,-2.70203 11.19688,-9.94115 16.35569,7.5315 7.21664,-9.46729 v -3.77076 l -2.0288,-1.54263 v -9.65879 l -10.27906,-6.85598 -2.02877,-4.0531 -0.37674,-5.02096 14.71337,-5.41416 -1.75828,-4.81935 7.96047,-1.26031 0.28006,-3.56909 5.36176,-3.96237 15.8244,32.25324 8.79134,-5.40409 v -9.08416 l 9.43855,-3.46828 6.84952,3.46828 -3.33296,8.01543 7.6803,0.77635 1.48778,6.66437 1.86713,1.56728 2.17682,3.70232 0.54514,3.14807 0.34321,2.33416 -1.02351,1.84702 0.83935,1.6561 -0.47623,3.20329 -1.71837,1.32488 -2.81608,-2.19579 -2.81112,-0.0472 -0.4835,0.82583 1.50287,2.27194 -0.34577,0.70364 -2.29649,-0.59546 -1.43827,-0.3155 -1.46576,0.88458 -0.0625,1.54502 5.14894,2.61493 -0.65034,5.24213 5.80086,2.64612 1.94885,0.57542 0.82271,2.03417 -0.77151,1.17481 2.21669,5.76079 1.94931,0.83073 2.6078,2.63832 2.00632,3.92734 5.03317,2.2195 1.03233,1.37659 1.04074,-0.67367 2.27773,0.12042 2.53965,3.6295 3.1102,-0.0415 -0.0146,2.47848 -1.16025,1.85835 1.88953,5.9368 3.95862,-0.92212 2.77328,0.96101 -1.01631,5.56694 4.07634,7.62255 3.2549,0.28542 0.79796,2.50975 3.78804,2.83664 0.0486,1.64951 -1.30378,0.70584 -1.90525,2.82954 -1.98511,8.33811 -5.61862,3.23603 -1.95668,10.96188 6.52058,6.93089 -2.4679,5.19834 h -3.88362 l -2.5408,12.65327 -3.33298,12.23989 -5.54529,13.15739 -4.75311,21.91887 z"
                  :fill="getRegionFillColor('KZ-ABAY')"
                  stroke="#D3D3D3"
                  id="KZ-ABAY"
                ></path>
                <path
                  d="m 692.82,98.43 -5.01,-2.13 -0.32,3.36 -12.64,6.07 -4.02,-0.65 -1.88,1.64 0.74,3.44 -8.04,5.5 -6.16,-0.58 -3.93,6.32 -3.78,-1.48 -1.8,2.88 2.46,1.23 -3.04,4.43 -2.46,-4.68 h -2.05 l -2.21,1.23 -1.3,-3.44 -2.36,-0.5 -2.7,2.71 -2.62,-1.31 -3,4.57 -1.39,4.02 2.73,2.2 -1.81,1.52 -2.84,-1.66 -0.71,5.67 h 3.55 l 3.47,-2.13 2.62,1.42 -4.67,5.5 v 6.74 h 3.01 l 6.72,-3.58 -0.42,4.13 -2.7,2.54 v 4.72 l 2.7,2.7 1.18,20.17 v 2.36 l -5.82,2.96 v 5.4 l 9.03,1.43 1.18,2.45 -9.28,2.87 -3.55,4.56 7.51,3.88 0.42,10.38 -2.61,3.63 v 6.41 l 12.4,-1.52 3.72,1.52 -1.02,2.62 4.14,1.01 3.63,2.7 0.34,3.63 4.05,3.29 -8.02,5.32 3.97,3.46 10.21,-7.09 5.99,-0.93 9.87,-1.77 3.88,1.77 2.7,-4.05 h 3.38 l 2.62,2.28 3.28,-11.73 7.17,-1.78 3.55,3.89 h 4.39 l 2.02,2.11 2.79,1.6 -1.52,5.91 3.54,1.26 16.8,7.18 7.51,-9.79 v -3.29 l -1.94,-2.03 -0.43,-9.11 -10.71,-7.01 -1.78,-3.96 -0.33,-4.65 15.19,-5.65 -1.69,-4.81 7.93,-1.1 0.42,-3.46 5.49,-4.13 -18.22,-32.24 -14.69,-22.61 -31.81,-25.07 -0.84,-4.64 5.82,0.34 4.22,-10.3 z"
                  :fill="getRegionFillColor('KZ-PAV')"
                  stroke="#D3D3D3"
                  id="KZ-PAV"
                ></path>
                <path
                  d="m 525.96063,292.5885 -7.96254,-0.11406 -9.80339,-11.54412 -9.7037,-0.69148 -1.75629,-10.59578 -6.35929,-9.0154 -5.2792,-8.0431 7.15532,-6.28518 -1.95539,-1.44521 0.33937,-3.47837 12.07154,-6.71762 -4.75882,-4.84387 0.33938,-3.39869 4.4196,1.27577 8.58974,-6.11964 h 5.69657 l 0.93779,8.24256 -2.8034,11.05316 8.65958,3.13955 9.18837,-7.81398 3.23239,6.45847 5.69656,-1.27571 h 6.80397 l -0.50881,7.30561 9.52752,-3.5681 -0.85796,-4.24584 3.40199,-1.4452 2.30457,1.69439 1.78577,-8.49169 h 4.58918 l 0.42898,-2.81066 12.81979,-8.24256 4.09036,4.50499 -0.25942,6.11961 8.67955,2.46183 0.84797,-4.50499 2.38441,-1.18607 1.18719,1.44519 2.0452,0.33903 v -6.45847 h 3.91075 l 4.24999,-6.11965 1.95539,1.19603 6.12555,-1.19603 0.33935,-3.47838 h 4.78872 l 4.23005,-3.14952 -1.4466,-3.0598 -3.74119,0.93689 -3.83098,-2.63124 v -2.80067 l 11.90195,-0.33903 7.32274,3.47842 0.84802,10.19599 -2.89318,3.73757 0.59859,6.37873 12.16133,-1.36546 3.06277,1.61465 -0.68837,2.72091 4.18013,1.10632 3.40199,2.4618 0.33936,3.90697 4.00057,3.22925 -7.74177,5.44184 4.00057,3.17941 9.94658,-6.91697 16.16189,-2.89035 3.49176,1.86378 2.8034,-3.90696 h 3.66137 l 2.37441,1.78404 3.32215,-11.38205 7.22297,-1.87376 3.32215,3.99668 h 4.41961 l 2.04516,1.95348 2.80339,1.87375 -1.5264,5.69104 3.14261,0.93688 -13.43833,12.82726 0.16967,4.58471 0.93779,2.38206 -4.33976,4.58473 -9.74702,2.89036 0.64846,5.44186 10.63494,9.25913 -5.10798,0.67775 -0.50876,6.11961 10.71471,0.33902 -2.29459,11.81063 -7.65193,0.59801 -0.76819,3.73755 2.21475,3.39868 2.2048,3.05981 8.00116,4.50499 -5.10799,6.70762 -2.89317,0.50832 0.429,14.96015 -3.7412,0.67773 -2.38436,5.69102 8.17071,6.28903 2.544,-3.31892 4.42958,1.19601 2.12497,17.67108 -8.50992,2.29241 -3.40197,-3.90699 -10.88434,1.61458 -9.52752,-4.3355 -15.03457,0.93683 -10.2259,6.54821 -4.53931,-0.0799 -17.00987,18.14949 -61.41569,0.52223 -1.1552,-19.6189 1.85134,-36.11738 3.74612,2.47576 3.69957,2.0968 1.57624,-5.85799 3.43419,-3.20641 4.76125,-1.0851 -3.99755,-7.97928 -2.67045,-9.30509 2.63794,-2.94126 0.24924,-10.89605 2.58489,-1.69317 0.46157,-5.40545 -1.92722,-1.69322 -1.39637,-3.01902 0.19606,-4.87513 -6.70472,0.9584 -0.0694,-3.01901 -4.79485,0.50477 -10.10321,0.76993 -3.99856,-2.14686 -2.40609,-4.53331 -4.27009,-0.55276 0.24207,8.99296 -2.14671,10.05361 -14.7524,2.94458 -5.70456,4.15557 -5.40713,0.25955 z"
                  :fill="getRegionFillColor('KZ-KAR')"
                  stroke="#D3D3D3"
                  id="KZ-KAR"
                ></path>
                <path
                  d="m 416.65972,307.30591 -1.18718,-2.28239 v -2.18273 l 5.95595,-1.28571 -1.78577,-5.6611 6.25522,-0.38872 v -9.1296 l 17.26931,4.36546 5.95594,-2.2824 0.89791,-3.96677 h 7.44245 l 16.7505,-20.77075 10.87671,-11.17985 5.30052,8.0713 6.37298,8.87488 1.68111,10.68283 9.85838,0.70548 9.65733,11.62032 8.04868,-0.0301 4.1611,6.19637 5.43457,-0.56677 5.03246,-4.04878 15.22056,-2.8435 2.15027,-9.67363 -0.12853,-9.47273 4.22813,0.5716 2.41837,4.72321 4.02706,1.9108 14.88543,-1.16942 -0.0445,2.90834 6.92686,-0.94088 -0.40075,4.5977 1.49615,3.43151 1.82789,1.62964 -0.44293,5.42079 -2.54173,1.63476 -0.31407,10.81731 -2.52672,3.0436 2.59914,9.31328 2.88756,5.6607 1.14489,2.24561 -4.61949,1.1073 -3.54705,3.18309 -1.60324,5.79459 -7.51726,-4.47266 -1.81594,36.02408 1.2045,19.72958 -93.9768,0.25165 -1.68604,-5.83058 -32.65302,-1.11625 -14.03692,-9.98676 -45.78207,-21.40863 -1.68602,1.2359 -7.85148,0.55813 6.50466,-4.5947 30.15888,-25.19601 -5.04808,-9.95682 z"
                  :fill="getRegionFillColor('KZ-ULT')"
                  stroke="#D3D3D3"
                  id="KZ-ULT"
                ></path>
                <path
                  d="m 355.39,201.58 h 4.99 l 1.32,5.43 2.62,1.57 h 4.56 v 5.26 l 6.13,4.03 -6.13,1.75 v 6.3 h 5.86 v 6.04 l 9.81,14.72 -0.26,5.86 h -6.84 l -5.42,10.6 v 12.35 l 9.98,12.34 5.52,-1.05 1.14,3.5 v 4.82 l 14.72,7.09 6.14,10.86 6.65,-5.69 -0.87,-2.72 v -2.1 l 5.95,-1.49 -1.75,-5.6 6.04,-0.35 0.35,-9.02 17.17,4.2 5.69,-2.19 1.4,-3.76 h 6.82 l 34.86,-38.62 -1.66,-1.84 0.26,-3.15 11.82,-6.74 -4.38,-4.29 -17.77,6.48 -4.29,-4.47 3.15,-2.54 -1.31,-2.97 -4.38,-0.44 -0.62,1.57 -4.99,-0.43 -2.01,-1.84 -4.2,-0.88 -0.71,-4.55 h -1.67 l -1.22,2.19 h -1.49 l -1.31,-6.04 -2.54,-0.71 -2.97,5.43 h -4.73 l -0.35,-9.89 -3.68,-7.79 2.28,-1.49 -0.79,-2.63 1.93,-7.97 h -4.73 v -3.76 l 4.2,-0.27 6.48,-5.34 4.02,-9.02 v -15.41 l 2.46,-9.19 4.11,0.7 v -2.72 l -5.16,-1.84 v -2.01 l 7.88,-1.05 v -2.01 l -3.5,-1.93 V 126.1 l -3.6,-0.26 v -4.47 l 1.14,-1.05 0.35,-3.94 h -2.45 l -0.35,-4.38 -2.28,-1.14 0.35,-1.92 5.08,-2.02 1.22,-3.5 -3.41,-2.72 3.06,-2.62 -2.1,-2.45 -1.92,-8.76 -0.88,-1.84 -3.5,-0.44 -1.32,3.24 -6.48,-1.22 v 2.62 l -6.48,0.53 0.53,6.48 -2.45,1.57 -3.94,-3.76 -11.56,4.03 -9.9,-0.27 v 3.94 l -1.83,0.71 -3.86,-2.02 -25.94,5.96 -4.46,1.22 h -9.55 l -3.06,1.58 h -6.74 l -1.76,-2.8 h -4.2 l -4.03,3.15 -2.93,2.45 4.86,3.68 -7.97,5.69 9.63,2.1 -2.54,6.57 1.23,4.46 10.77,1.06 9.2,3.76 v 5.08 l -2.46,1.05 -2.01,-1.05 -5.78,1.05 -2.8,-1.84 h -7.8 l -7.44,7.71 h -3.94 l 0.44,5.16 2.28,3.42 3.76,2.1 1.66,5.08 -8.14,6.39 h -5.43 l -1.84,3.68 -7.26,2.63 -0.53,2.36 4.47,0.96 6.65,4.12 -3.33,3.85 12.22,0.79 2.1,6.13 5.69,1.14 5.17,0.44 2.8,3.94 z"
                  :fill="getRegionFillColor('KZ-KUS')"
                  stroke="#D3D3D3"
                  id="KZ-KUS"
                ></path>
                <path
                  d="m 456.95,95.28 2.39,2.86 -3.09,2.55 3.09,2.77 -1.08,3.47 -5.09,1.85 -0.31,1.93 2.08,1.31 0.47,4.01 2.31,0.31 -0.23,3.7 -1.08,1.46 v 4.32 l 3.31,0.39 v 10.02 l 3.63,2.39 v 2.23 l -7.64,0.85 0.17,2.01 4.92,1.85 v 2.54 l -4.16,-0.31 -2.39,8.64 -0.31,7.02 5.78,4.24 1.39,-1.62 h 5.71 l 0.23,2.77 h 3.31 l 12.88,2.93 0.93,-7.78 h 5.47 l 3.32,2.46 3.39,2.39 3.86,-2.39 0.54,-4.01 v -2.23 l 3.93,-1.62 7.48,-7.1 3.77,-0.38 -2.54,-5.55 5.24,-2.7 -2.23,-5.71 -0.47,-2.23 -3.16,-0.93 -1.46,-3.16 0.23,-3.47 3.08,-2.54 h 2.55 v -3.93 l 2.77,0.23 3.01,1.08 1.7,-2.47 5.29,6.09 3.08,-4.09 8.4,-0.23 0.54,4.32 4.63,-0.39 0.93,2.7 -2.39,1.7 -0.24,2.16 5.94,0.31 1.77,3.7 3.78,0.23 2.7,-6.4 9.65,-0.23 0.68,2.7 5.86,0.84 4.25,-3.54 4.67,7.55 -1.31,6.79 3.16,2.93 10.56,0.23 2.49,-3.16 11.93,-0.62 0.62,9.64 5.55,0.31 5.24,1.15 4.01,3.32 h 7.86 l 0.23,-4.47 2.55,-2.47 0.23,-3.93 -6.55,3.47 -3.09,-0.23 0.23,-6.79 4.24,-5.24 -2.54,-1.31 -3.39,2.16 -3.09,-0.31 v -5.48 l 3.09,1.55 1.69,-1.78 -2.31,-2.08 -6.78,-6.01 0.23,-3.09 5.09,-8.01 h 5.86 l 1.46,-5.79 -3.55,-1.46 -8.4,3.93 -3.78,-0.62 -3.54,-4.35 -6.69,-0.97 -2.77,9.26 -3.63,-1.7 1.7,-8.56 -1.7,-3.17 -7.15,-5.01 -2.48,5.01 -3.94,1.03 -0.43,4.11 -4.45,0.13 -1.12,-2.79 -3.94,0.35 -2.18,2.74 -3.68,-3.3 1.11,-3.9 2.1,-4.62 V 88.6 l 2.65,-1.07 -0.64,-2.94 h -4.28 l -2.57,-7.13 0.64,-6.85 -4.92,-7.49 -7.71,1.28 -6.17,4.5 -6.68,-2.79 v -2.99 l -3.64,-2.14 -7.92,-1.07 -2.79,1.71 -7.06,-3.64 -4.93,3.64 -2.78,5.14 -10.71,0.85 3.86,4.5 -5.57,4.07 -2.57,-1.71 h -2.79 l -0.85,3.85 h -11.78 l -5.99,3.64 h -6.21 l -15.64,5.57 z"
                  :fill="getRegionFillColor('KZ-SEV')"
                  stroke="#D3D3D3"
                  id="KZ-SEV"
                ></path>
                <path
                  d="m 454.23,172.42 -4.23,8.97 -6.46,5.47 h -4.22 v 3.77 h 4.49 l -1.71,8.19 0.9,2.57 -2.06,1.35 3.41,8.07 0.36,9.68 h 4.84 l 3.31,-5.56 2.16,1.08 1.25,5.56 h 1.53 l 1.17,-2.06 1.79,0.54 0.47,4.12 4.46,0.81 2.06,2.06 h 4.77 l 0.9,-1.34 4.31,0.53 1.25,3.14 -3.23,2.25 4.49,4.39 17.58,-6.64 0.35,-3.49 4.58,1.16 8.61,-5.92 h 5.56 l 0.81,8.25 -2.69,10.95 8.87,3.13 9.16,-7.44 3.22,6.37 5.66,-1.26 h 6.82 l -0.44,7 9.32,-3.59 -0.8,-3.86 3.4,-1.88 2.52,1.88 1.52,-8.52 h 4.75 l 0.45,-2.78 12.92,-8.25 3.94,4.76 v 5.91 l 8.61,2.34 0.9,-4.76 2.24,-0.89 0.99,1.43 2.42,0.27 v -6.28 l 3.86,-0.36 4.03,-6.09 2.16,1.34 6,-1.08 0.27,-3.49 h 5.2 l 3.95,-3.23 -1.52,-2.96 -3.86,0.72 -3.5,-2.69 v -2.7 l 12.02,-0.24 3.41,-4.69 8.88,-3.14 -1.17,-2.06 -8.61,-1.7 0.27,-5.3 5.29,-2.96 -1.52,-22.87 -2.87,-2.78 h -7.36 l -4.21,-3.31 -5.2,-1.08 -5.47,-0.45 -0.63,-9.59 -11.84,0.62 -2.69,2.87 h -10.67 l -2.87,-2.87 1.16,-6.72 -4.57,-7.36 -4.4,3.23 -5.56,-0.9 -0.72,-2.33 h -9.59 l -2.96,6.46 -3.68,-0.54 -1.97,-3.59 -5.48,-0.35 v -1.98 l 2.33,-1.97 -0.99,-2.24 h -4.48 l -0.72,-3.77 h -8.16 l -3.14,3.77 -5.38,-5.92 -1.8,2.51 -2.78,-0.9 -2.78,-0.54 -0.27,4.13 h -2.42 l -3.14,2.69 v 3.41 l 1.44,3.14 2.96,0.98 2.78,7.81 -5.2,2.42 2.42,5.56 -3.5,0.72 -7.53,7.35 -4.04,1.26 -0.54,6.54 -3.67,1.98 -7,-4.85 h -5.29 l -0.99,7.63 -13.27,-2.78 h -2.78 l -0.63,-2.52 h -5.29 l -1.7,1.44 -5.3,-3.77 z"
                  :fill="getRegionFillColor('KZ-AKM')"
                  stroke="#D3D3D3"
                  id="KZ-AKM"
                ></path>
                <path
                  d="m 589.57564,209.85577 c 0,5.78 -4.96,10.48 -11.05,10.48 -6.1,0 -11.05,-4.7 -11.05,-10.48 0,-5.78 4.95,-10.48 11.05,-10.48 6.09,0 11.05,4.7 11.05,10.48 z"
                  :fill="getRegionFillColor('KZ-AST')"
                  stroke="#D3D3D3"
                  id="KZ-AST"
                ></path>
                <path
                  d="m 720.41,482.02 c 0,5.78 -4.95,10.48 -11.04,10.48 -6.1,0 -11.05,-4.7 -11.05,-10.48 0,-5.79 4.95,-10.48 11.05,-10.48 6.09,0 11.04,4.69 11.04,10.48 z"
                  :fill="getRegionFillColor('KZ-ALT')"
                  stroke="#D3D3D3"
                  id="KZ-ALT"
                ></path>
                <path
                  d="m 545.99231,523.63717 c 0,5.78 -4.96,10.48 -11.05,10.48 -6.1,0 -11.05,-4.7 -11.05,-10.48 0,-5.78 4.95,-10.48 11.05,-10.48 6.09,0 11.05,4.7 11.05,10.48 z"
                  :fill="getRegionFillColor('KZ-SHYM')"
                  stroke="#D3D3D3"
                  id="KZ-SHYM"
                ></path>
              </svg>

              <div
                v-if="hoveredRegion"
                class="hovered-region"
                :style="{
                  transform:
                    'translate(' +
                    mouseCoords.x +
                    'px, ' +
                    mouseCoords.y +
                    'px)'
                }"
              >
                <span>{{ getCountryName(hoveredRegion) }}</span> -
                <span
                  >{{ hoveredRegion.value }} % ({{ hoveredRegion.count }})</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container colorDescriptions-main">
        <div class="row">
          <div class="col">
            <ul class="colorDescriptions">
              <li>
                <div class="colorDescriptions-colorBlock"></div>
                <p class="colorDescriptions-num">0</p>
              </li>
              <li>
                <div class="colorDescriptions-colorBlock"></div>
                <p class="colorDescriptions-num">
                  1 - 50
                  <span>({{ $t('touchbord.low') }})</span>
                </p>
              </li>
              <li>
                <div class="colorDescriptions-colorBlock"></div>
                <p class="colorDescriptions-num">
                  51 - 100
                  <span>({{ $t('touchbord.normal') }})</span>
                </p>
              </li>
              <li>
                <div class="colorDescriptions-colorBlock"></div>
                <p class="colorDescriptions-num">
                  101 - {{ $t('touchbord.more') }}
                  <span>({{ $t('touchbord.high') }})</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section">
    <div class="container">
      <div class="row">
        <div class="col">
          <h2 class="task-name12">
            <p>{{ $t('touchbord.popularRegions') }}</p>

            <button class="hint" type="button">
              <SvgIcon name="questionMark" />

              <div class="hint-content">
                {{ $t('touchbord.hintContentTopRegion') }}
              </div>
            </button>
          </h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="touch-board-countries">
        <div
          class="touch-board-countries-item touch-board-countries-item--region"
          v-for="(region, index) in topRegions"
          :key="index"
        >
          <img
            :src="require('@/assets/images/regions/' + region.name_kk + '.png')"
          />
          <div class="country-content">
            <p class="name">{{ getRegionName(region) }}</p>
            <p class="quantity">
              {{ region.arrival_sheets_share }} % ({{
                region.arrival_sheets_count
              }})
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section">
    <div class="container">
      <div class="row">
        <div class="col">
          <h2 class="task-name12">
            <p>{{ $t('touchbord.touristsByCountry') }}</p>
            <button class="hint" type="button">
              <SvgIcon name="questionMark" />

              <div class="hint-content">
                {{ $t('touchbord.hintContent') }}
              </div>
            </button>
          </h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="wordMap">
            <div id="chartdiv2" class="chartdiv2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section">
    <div class="container">
      <div class="row">
        <div class="col">
          <h2 class="task-name12">
            <p>{{ $t('touchbord.popularCountries') }}</p>

            <button class="hint" type="button">
              <SvgIcon name="questionMark" />

              <div class="hint-content">
                {{ $t('touchbord.hintContentTop') }}
              </div>
            </button>
          </h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="touch-board-countries">
        <div
          class="touch-board-countries-item"
          v-for="(country, index) in topCountry"
          :key="index"
        >
          <img :src="country.flag" />
          <div class="country-content">
            <p class="name">{{ getCountryName(country) }} </p>
            <p class="quantity">
              {{ country.arrival_sheets_share }} % ({{
                country.arrival_sheets_count
              }})
            </p>
          </div>
        </div>
        <!-- <div class="touch-board-countries-item">
                        <SvgIcon name="countryFlag-Turkey" />
                        <div class="country-content">
                            <p class="name">Турция</p>
                            <p class="quantity">11%</p>
                        </div>
                    </div>
                    <div class="touch-board-countries-item">
                        <SvgIcon name="countryFlag-Uzbekistan" />
                        <div class="country-content">
                            <p class="name">Узбекисан</p>
                            <p class="quantity">7%</p>
                        </div>
                    </div>
                    <div class="touch-board-countries-item">
                        <SvgIcon name="countryFlag-Ukraine" />
                        <div class="country-content">
                            <p class="name">Украина</p>
                            <p class="quantity">6%</p>
                        </div>
                    </div>
                    <div class="touch-board-countries-item">
                        <SvgIcon name="countryFlag-Germany" />
                        <div class="country-content">
                            <p class="name">Германия</p>
                            <p class="quantity">3%</p>
                        </div>
                    </div>
                    <div class="touch-board-countries-item">
                        <SvgIcon name="countryFlag-United_Kingdom" />
                        <div class="country-content">
                            <p class="name">Великобритания</p>
                            <p class="quantity">3%</p>
                        </div>
                    </div>
                    <div class="touch-board-countries-item">
                        <SvgIcon name="countryFlag-Belarus" />
                        <div class="country-content">
                            <p class="name">Беларусь</p>
                            <p class="quantity">3%</p>
                        </div>
                    </div>
                    <div class="touch-board-countries-item">
                        <SvgIcon name="countryFlag-Kyrgyzstan" />
                        <div class="country-content">
                            <p class="name">Кыргызтан</p>
                            <p class="quantity">4%</p>
                        </div>
                    </div>
                    <div class="touch-board-countries-item">
                        <SvgIcon name="countryFlag-China" />
                        <div class="country-content">
                            <p class="name">КНР</p>
                            <p class="quantity">5%</p>
                        </div>
                    </div>
                    <div class="touch-board-countries-item">
                        <SvgIcon name="countryFlag-Tajikistan" />
                        <div class="country-content">
                            <p class="name">Таджикистан</p>
                            <p class="quantity">2%</p>
                        </div>
                    </div> -->
      </div>
    </div>
  </div>

  <div class="section">
    <div class="container">
      <div class="row">
        <div class="col">
          <h2 class="task-name12">
            <p>{{ $t('touchbord.Portrait') }}</p>

            <button class="hint" type="button">
              <SvgIcon name="questionMark" />

              <div class="hint-content">
                {{ $t('touchbord.hintContentPortrait') }}
              </div>
            </button>
          </h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="portraitTourist">
        <div class="row">
          <div class="col-6">
            <div class="portraitTourist-block">
              <div class="portraitTourist-title">
                {{ $t('touchbord.gender') }}
              </div>
              <div class="portraitTourist-items">
                <div class="portraitTourist-item man">
                  <div class="portraitTourist-content">
                    <div class="portraitTourist-name">
                      {{ $t('touchbord.man') }}
                    </div>
                    <div class="portraitTourist-human">
                      <SvgIcon name="human" />
                    </div>

                    <div class="portraitTourist-quantity">
                      {{ Math.round(genderValue[1]) }}%
                    </div>
                  </div>

                  <div class="portraitTourist-previews">
                    <SvgIcon
                      name="human"
                      v-for="man in manArray"
                      :key="man"
                      :style="{ fill: man }"
                    />
                  </div>
                </div>
                <div class="portraitTourist-item woman">
                  <div class="portraitTourist-content">
                    <div class="portraitTourist-quantity">
                      {{ Math.round(genderValue[0]) }}%
                    </div>
                    <div class="portraitTourist-human">
                      <SvgIcon name="woman" />
                    </div>

                    <div class="portraitTourist-name">
                      {{ $t('touchbord.woman') }}
                    </div>
                  </div>

                  <div class="portraitTourist-previews">
                    <svg
                      v-for="woman in womanArray"
                      :key="woman"
                      viewBox="0 0 18 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.5024 18.1305C15.6594 18.6776 15.9676 19.171 16.5402 19.171C17.1139 19.171 17.5808 18.7049 17.5808 18.1305L15.0223 8.56411C14.6045 7.21557 13.9589 6.18762 12.6419 6.18762H5.30953C3.99889 6.18762 3.28135 7.32624 2.93142 8.56411L0.387207 18.1653C0.387207 18.7397 0.853008 19.2046 1.4267 19.2046C1.99925 19.2046 2.25784 18.7831 2.46334 18.1653L5.01498 9.39068H5.45509L1.43697 23.6981H5.45509V32.8583C5.45509 33.7168 6.15095 34.4145 7.01348 34.4145C7.87145 34.4145 8.5673 33.7168 8.5673 32.8583V23.6981H9.41899V32.8572C9.41899 33.7168 10.1177 34.4145 10.9774 34.4145C11.8353 34.4145 12.534 33.7168 12.534 32.8572V23.6981H16.688L12.534 9.39068H12.9508L15.5024 18.1305Z"
                        :fill="woman"
                      />
                      <path
                        d="M9.05928 5.21616C10.5024 5.21616 11.6714 4.04618 11.6714 2.60694C11.6714 1.16713 10.5024 0 9.05928 0C7.61906 0 6.45227 1.16713 6.45227 2.60694C6.45227 4.04618 7.61906 5.21616 9.05928 5.21616Z"
                        :fill="woman"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="portraitTourist-block">
              <div class="portraitTourist-title">
                {{ $t('touchbord.TouristAge') }}
              </div>
              <div class="portraitTourist-graphic">
                <div class="portraitTourist-graphicPie">
                  <div class="divchartpie"></div>
                </div>

                <div class="Pielegend-items">
                  <div
                    class="Pielegend-item"
                    v-for="(item, itemInd) of dataToLegend"
                    :key="item.age"
                  >
                    <div class="Pielegend-title">
                      <div class="Pielegend-marker"></div>
                      {{
                        item.age +
                        $t(getAgeRangeTranslate(dataToLegend.length, itemInd))
                      }}
                    </div>
                    <div class="Pielegend-quantity">
                      {{ item.arrival_sheets_share }} %
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section">
    <div class="container">
      <div class="row">
        <div class="col">
          <h2 class="task-name12">
            <p>{{ $t('touchbord.purpose') }}</p>

            <button class="hint" type="button">
              <SvgIcon name="questionMark" />

              <div class="hint-content">
                {{ $t('touchbord.hintContentPurpose') }}
              </div>
            </button>
          </h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="purposeVisits">
        <div class="row">
          <div class="col-6" v-for="(item, index) in countVisit" :key="index">
            <div class="purposeVisits-info">
              <div class="purposeVisits-content">
                <p class="purposeVisits-name">
                  {{ getHintName(item) }}
                </p>
                <p class="purposeVisits-quantity">
                  {{ item.arrival_sheet_share }} %
                </p>
              </div>
              <div class="purposeVisits-graphics">
                <span
                  :style="{
                    width: item.arrival_sheet_share + '%'
                  }"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section">
    <div class="container">
      <div class="row">
        <div class="col">
          <h2 class="task-name12">
            <p>{{ $t('touchbord.placements') }}</p>
            <button class="hint" type="button">
              <SvgIcon name="questionMark" />

              <div class="hint-content">
                {{ $t('touchbord.hintContentPlacements') }}
              </div>
            </button>
          </h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="hotels">
        <div class="hotels-col" v-for="hotel in topHotel" :key="hotel">
          <div class="hotels-hotel">
            <div class="hotels-preview">
              <img src="@/assets/icons/iconHotel.png" />
            </div>

            <div class="hotels-content">
              <p class="name">{{ hotel.name }}</p>
              <p class="quantity">
                {{ hotel.arrival_sheets_share }} % ({{
                  hotel.arrival_sheets_count
                }})
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Downloaded v-if="!downloaded" />
</template>

<script>
  import { defineComponent, ref, computed, watch, onMounted } from 'vue'
  import { onBeforeRouteLeave } from 'vue-router'
  import axios from 'axios'
  import { useI18n } from 'vue-i18n'

  import getWeekStartAndEndDates from '@/helpers/getWeekStartAndEndDates'

  import * as am4core from '@amcharts/amcharts4/core'
  import * as am4maps from '@amcharts/amcharts4/maps'
  import * as am4charts from '@amcharts/amcharts4/charts'
  import am4geodata_kazakhstan from '@amcharts/amcharts4-geodata/kazakhstanHigh'
  import am4geodataWorld from '@amcharts/amcharts4-geodata/worldLow'
  import am4themes_animated from '@amcharts/amcharts4/themes/animated'

  import BreadCrumbs from '@/components/ui/BreadCrumbs.vue'
  import LineChart from '@/components/LineChart.vue'
  import MainTopLine from '@/components/MainTopLine.vue'
  import Downloaded from '@/components/download.vue'

  am4core.useTheme(am4themes_animated)

  const regionsTranslates = {
    en: 'name_en',
    ru: 'name_ru',
    kz: 'name_kk'
  }

  const countriesTranslates = {
    en: 'name_en',
    ru: 'name_ru',
    kz: 'name_kk'
  }

  const targetTranslates = {
    en: 'name_en',
    ru: 'name_ru',
    kz: 'name_kk'
  }

  export default defineComponent({
    components: {
      BreadCrumbs,
      MainTopLine,
      LineChart,
      Downloaded
    },
    setup() {
      const i18n = useI18n()

      let dateDay = ref('day')
      let dateWeek = ref('week')
      let dateMes = ref('month')
      let dateYear = ref('year')
      let quater = ref(0)
      let period = ref(0)
      let denIsActive = ref('month')
      let periodValue = computed(() => {
        let start, end
        const date = new Date()
        if (denIsActive.value === 'week') {
          let { start: s, end: e } = getWeekStartAndEndDates(date)
          start = s
          end = e
        } else if (denIsActive.value === 'month') {
          let month = date.getMonth('en-GB', {
            month: '2-digit'
          })
          month = month < 10 ? '0' + month : month
          start = `${date.getFullYear()}-${month}-01`
          end = `${date.getFullYear()}-${month}-${getDays(
            date.getFullYear(),
            date.getMonth()
          )}`
        } else if (denIsActive.value === 'year') {
          start = `${date.getFullYear()}-01-01`
          end = `${date.getFullYear()}-12-31`
        } else if (denIsActive.value === 'period') {
        } else if (denIsActive.value === 'quaterTitle') {
          if (quater.value === 1) {
            start = `${date.getFullYear()}-04-01`
            end = `${date.getFullYear()}-06-30`
          } else if (quater.value === 2) {
            start = `${date.getFullYear()}-07-01`
            end = `${date.getFullYear()}-09-30`
          } else if (quater.value === 3) {
            start = `${date.getFullYear()}-10-01`
            end = `${date.getFullYear()}-12-31`
          } else {
            start = `${date.getFullYear()}-01-01`
            end = `${date.getFullYear()}-03-31`
          }
        } else {
          start = date
            .toLocaleDateString('en-GB', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            })
            .split('/')
            .reverse()
            .join('-')
          end = start
        }

        return window.encodeURI(
          `filter[check_in][start]=${start}&filter[check_in][end]=${end}`
        )
      })
      const getDays = (year, month) => {
        return new Date(year, month, 0).getDate()
      }
      let app
      let allCountries = ref([])
      let countriesDataList = []
      let downloaded = ref(false)
      am4core.addLicense('ch-custom-attribution')
      let darkStyle = ref(false)
      let genderValue = ref([])
      let woman = ref(0)
      let man = ref(0)
      let regionsData = []
      let countVisit = ref()
      let totalCountVisit = ref(0)
      let topCountry = ref([])
      let topRegions = ref([])
      let topHotel = ref([])
      let regions = []
      let hoveredRegion = ref(null)
      let mouseCoords = ref({
        x: 0,
        y: 0
      })
      const manArray = ref([])
      const womanArray = ref([])

      watch(i18n.locale, () => {
        downloaded.value = false
        getWorldGraphic()
        downloaded.value = true
      })

      watch([quater, period], () => {
        getEqonaq()
      })

      let cityValues = []
      function changeDate(value) {
        denIsActive.value = value
        if (!(denIsActive.value === 'period')) {
          getEqonaq()
        }
      }
      let pieGtraphics
      onMounted(() => {
        // getWorldGraphic()
        pieGtraphics = am4core.create('divchartpie', am4charts.PieChart)
        if (pieGtraphics.logo) {
          pieGtraphics.logo.disabled = true
        }
        getGraphics()
        app = document.querySelector('#app')
        app.style.background = '#f4f4f4'
      })
      onBeforeRouteLeave(() => {
        app.style.background = 'transparent'
      })
      const dataToLegend = ref([
        {
          age: 'до 18 лет',
          arrival_sheets_share: 10,
          value: 260,
          value2: 100
        },
        {
          age: '18-25 лет',
          arrival_sheets_share: 10,
          value: 230,
          value2: 200
        },
        {
          age: '25-35 лет',
          arrival_sheets_share: 10,
          value: 200,
          value2: 500
        },
        {
          age: '35-45 лет',
          arrival_sheets_share: 10,
          value: 165,
          value2: 300
        },
        {
          age: 'Старше 45 лет',
          arrival_sheets_share: 10,
          value: 139,
          value2: 400
        }
      ])
      let data = [
        { name: 'Акмолинская область', id: 'KZ-AKM' },
        { name: 'Актюбинская область', id: 'KZ-AKT' },
        { name: 'Алматинская область', id: 'KZ-ALM' },
        { name: 'Атырауская область', id: 'KZ-ATY' },
        { name: 'Карагандинская область', id: 'KZ-KAR' },
        { name: 'Костанайская область', id: 'KZ-KUS' },
        { name: 'Кызылординская область', id: 'KZ-KZY' },
        { name: 'Мангистауская область', id: 'KZ-MAN' },
        { name: 'Павлодарская область', id: 'KZ-PAV' },
        { name: 'Северо-Казахстанская область', id: 'KZ-SEV' },
        { name: 'Восточно-Казахстанская область', id: 'KZ-VOS' },
        { name: 'Туркестанская область', id: 'KZ-YUZ' },
        { name: 'Западно-Казахстанская область', id: 'KZ-ZAP' },
        { name: 'Жамбылская область', id: 'KZ-ZHA' },
        { name: 'область Жетісу', id: 'KZ-JET' },
        { name: 'область Абай', id: 'KZ-ABAY' },
        { name: 'область Ұлытау', id: 'KZ-ULT' },
        { name: 'г. Астана', id: 'KZ-AST' },
        { name: 'г.Алматы', id: 'KZ-ALT' },
        { name: 'г. Шымкент', id: 'KZ-SHYM' }
      ]
      let dataCityPolygon = [
        { name: 'Караганда Г.А.', id: 'KZ-KAR' },
        { name: 'г.Алматы', id: 'KZ-ALM' },
        { name: 'Талдыкорган Г.А.', id: 'KZ-ALM' },
        { name: 'Актау Г.А.', id: 'KZ-MAN' },
        { name: 'Кызылорда Г.А.', id: 'KZ-KZY' },
        { name: 'Павлодар Г.А.', id: 'KZ-PAV' },
        { name: 'Тараз Г.А.', id: 'KZ-ZHA' },
        { name: 'г.Нур-Султан', id: 'KZ-AKM' },
        { name: 'Кокшетау Г.А.', id: 'KZ-AKM' },
        { name: 'Атырау Г.А.', id: 'KZ-ATY' },
        { name: 'Костанай Г.А.', id: 'KZ-KUS' },
        { name: 'Петропавловск Г.А.', id: 'KZ-SEV' },
        { name: 'Семей Г.А.', id: 'KZ-VOS' },
        { name: 'Усть-Каменогорск Г.А.', id: 'KZ-VOS' },
        { name: 'г. Шымкент', id: 'KZ-YUZ' },
        { name: 'Уральск Г.А.', id: 'KZ-ZAP' },
        { name: 'Актобе Г.А.', id: 'KZ-AKT' }
      ]
      let dataCoordinate = [
        {
          name: 'г.Алматы',
          latitude: '43.10753786333691',
          longitude: '77.7274722544264'
        },
        { name: 'г. Шымкент', latitude: '42.3', longitude: '69.6' },
        {
          name: 'г.Нур-Султан',
          latitude: '51.39501998867756',
          longitude: '71.50463613050697'
        },
        {
          name: 'Актау Г.А.',
          latitude: '43.634658545899676',
          longitude: '51.21391358745578'
        },
        {
          name: 'Туркестан Г.А.',
          latitude: '68.2517',
          longitude: '43.2973'
        },
        {
          name: 'Уральск Г.А.',
          latitude: '51.2333',
          longitude: '51.3667'
        },
        {
          name: 'Павлодар Г.А.',
          latitude: '52.2833',
          longitude: '76.9667'
        },
        {
          name: 'Петропавловск Г.А.',
          latitude: '54.8667',
          longitude: '69.15'
        },
        {
          name: 'Талдыкорган Г.А.',
          latitude: '45.0156',
          longitude: '78.3739'
        },
        {
          name: 'Семей Г.А.',
          latitude: '50.4268',
          longitude: '80.2667'
        },
        {
          name: 'Кокшетау Г.А.',
          latitude: '53.2833',
          longitude: '69.4'
        },
        {
          name: 'Караганда Г.А.',
          latitude: '49.8019',
          longitude: '73.1021'
        },
        {
          name: 'Усть-Каменогорск Г.А.',
          latitude: '49.9714',
          longitude: '82.6059'
        },
        {
          name: 'Актобе Г.А.',
          latitude: '50.2797',
          longitude: '57.2072'
        },
        {
          name: 'Атырау Г.А.',
          latitude: '47.1167',
          longitude: '51.8833'
        },
        {
          name: 'Кызылорда Г.А.',
          latitude: '44.8479',
          longitude: '65.4999'
        },
        {
          name: 'Тараз Г.А.',
          latitude: '42.8984',
          longitude: '71.3980'
        },
        {
          name: 'Костанай Г.А.',
          latitude: '53.2198',
          longitude: '63.6354'
        }
      ]
      const round = (item) => Math.round(item)

      let totalValue = 0

      for (const item of dataToLegend.value) {
        totalValue += item.arrival_sheets_share
      }

      function mouseover(e) {
        const item = regionsData.find((i) => i.id == e.target?.id)
        hoveredRegion.value = item
          ? {
              ...item,
              name_ru: item.name
            }
          : null

        mouseCoords.value = {
          x: e.clientX,
          y: e.clientY
        }
      }

      const getRegionFillColor = computed(() => (id) => {
        return regionsData.find((r) => r.id === id)?.fill || '#f95050'
      })

      function getGraphics() {
        pieGtraphics.align = 'center'
        pieGtraphics.hiddenState.properties.opacity = 0

        pieGtraphics.maxwidth = '100%'
        pieGtraphics.maxheight = '100%'
        pieGtraphics.align = 'left'

        pieGtraphics.data = [
          {
            country: 'до 18 лет',
            value: 260,
            value2: 100
          },
          {
            country: '18-25 лет',
            value: 230,
            value2: 200
          },
          {
            country: '25-35 лет',
            value: 200,
            value2: 500
          },
          {
            country: '35-45 лет',
            value: 165,
            value2: 300
          },
          {
            country: 'Старше 45 лет',
            value: 139,
            value2: 400
          }
        ]

        var series = pieGtraphics.series.push(new am4charts.PieSeries())
        series.dataFields.value = 'value'
        series.dataFields.radiusValue = 'value'
        series.dataFields.category = 'country'
        series.colors.step = 3
        series.ticks.template.disabled = true
        series.labels.template.disabled = true

        series.colors = new am4core.ColorSet()
        series.colors.list = [
          am4core.color('#0194EB'),
          am4core.color('#FB8832'),
          am4core.color('#944CEE'),
          am4core.color('#55DCE7'),
          am4core.color('#2FFC8D'),
          am4core.color('#fc2f2f')
        ]

        series.labels.template.paddingTop = 0
        series.labels.template.paddingBottom = 0

        series.slices.template.tooltipText = '{value}'
        series.tooltip.getFillFromObject = false
        series.tooltip.label.fill = am4core.color('#000')
        series.tooltip.label.fontSize = 14

        series.hiddenState.properties.endAngle = -90

        pieGtraphics.radius = am4core.percent(90)
      }

      let message = ref('hello')
      let map
      let worldMap
      let citiesMap

      function getCountryGraphic() {
        if (map) map.dispose()

        map = am4core.create('chartdiv', am4maps.MapChart)
        if (map.logo) {
          map.logo.disabled = true
        }
        map.projection = new am4maps.projections.Mercator()
        map.height = '100%'
        map.width = '100%'
        map.maxHeight = 680

        map.align = 'center'
        map.maxZoomLevel = 1
        map.chartContainer.wheelable = false
        map.seriesContainer.events.disableType('doublehit')
        map.chartContainer.background.events.disableType('doublehit')

        map.seriesContainer.draggable = false
        map.seriesContainer.resizable = false

        if (map.logo) {
          map.logo.disabled = true
        }

        let polygonSeries = new am4maps.MapPolygonSeries()

        polygonSeries.data = regionsData
        let polygonTemplate = polygonSeries.mapPolygons.template
        polygonTemplate.tooltipText = '{name}: {value}%'
        polygonTemplate.propertyFields.fill = 'fill'

        let hoverState = polygonTemplate.states.create('hover')
        hoverState.properties.fill = am4core.color('#ca9e67')

        polygonSeries.useGeodata = true
        let imageSeries = map.series.push(new am4maps.MapImageSeries())

        let imageSeriesTemplate = imageSeries.mapImages.template
        imageSeriesTemplate.propertyFields.latitude = 'latitude'
        imageSeriesTemplate.propertyFields.longitude = 'longitude'

        polygonSeries.calculateVisualCenter = true

        let labelTemplate = imageSeries.mapImages.template.createChild(
          am4core.Label
        )
        labelTemplate.horizontalCenter = 'middle'
        labelTemplate.verticalCenter = 'middle'
        labelTemplate.fontSize = 10
        labelTemplate.nonScaling = true
        labelTemplate.interactionsEnabled = false

        polygonSeries.events.on('inited', function () {
          for (let polygon of polygonSeries.mapPolygons) {
            let label = imageSeries.mapImages.create()
            let state = polygon.dataItem.dataContext

            label.latitude = polygon.visualLatitude
            label.longitude = polygon.visualLongitude
            label.children.getIndex(0).text = state
          }
        })
        map.series.push(polygonSeries)
      }

      function getWorldGraphic() {
        if (worldMap) {
          worldMap.dispose()
        }

        worldMap = am4core.create('chartdiv2', am4maps.MapChart)
        if (worldMap.logo) {
          worldMap.logo.disabled = true
        }

        if (worldMap.logo) {
          worldMap.logo.disabled = true
        }
        // Set map definition
        worldMap.geodata = am4geodataWorld
        worldMap.chartContainer.wheelable = false

        // Set projection
        worldMap.projection = new am4maps.projections.Miller()
        // Create map polygon series
        var polygonSeries = worldMap.series.push(new am4maps.MapPolygonSeries())
        polygonSeries.useGeodata = true
        polygonSeries.data = countriesDataList.map((e) => {
          const findCountry = am4geodataWorld.features.find((c) => {
            return e.name
              ?.toLowerCase()
              .includes(c?.properties?.name.toLowerCase())
          })
          return {
            ...e,
            id: (findCountry && findCountry.properties.id) || e.id
          }
        })
        // Make map load polygon (like country names) data from GeoJSON

        // Configure series
        var polygonTemplate = polygonSeries.mapPolygons.template
        polygonTemplate.tooltipHTML =
          '<div style="display:flex;min-width: 170px;white-space:wrap;max-width: 300px;"> <img src="https://api.eqonaq.kz/{flag}" style="height:30px;margin-right:12px" /><div>{' +
          countriesTranslates[i18n.locale.value] +
          '} {value}%</div></div>'
        // polygonTemplate.tooltipText = "{item}: {value}";
        polygonTemplate.maxWidth = 300
        polygonTemplate.width = 100
        polygonTemplate.minWidth = 100
        // polygonTemplate.label.maxWidth = 300;
        // polygonTemplate.label.wrap = true;
        polygonTemplate.fill = am4core.color('#D9D9D9')
        polygonTemplate.propertyFields.fill = 'fill'
        worldMap.tooltip.background.cornerRadius = 3
        // Set up tooltips
        polygonSeries.calculateVisualCenter = true
        polygonTemplate.tooltipPosition = 'fixed'
        polygonSeries.tooltip.label.interactionsEnabled = true
        polygonSeries.tooltip.keepTargetHover = true

        // Create hover state and set alternative fill color
        var hs = polygonTemplate.states.create('hover')
        hs.properties.fill = am4core.color('#ca9e67')

        polygonSeries.tooltip.getFillFromObject = false
        polygonSeries.tooltip.label.fill = am4core.color('#000')

        // Remove Antarctica
        polygonSeries.exclude = ['AQ']

        // Add zoom control
        worldMap.zoomControl = new am4maps.ZoomControl()
        worldMap.height = '100%'
        worldMap.width = '100%'
        worldMap.maxHeight = 620
      }

      function pageStyle() {
        darkStyle.value = !darkStyle.value
      }
      async function getTopCountries() {
        try {
          downloaded.value = false
          const response = await axios.get(
            'https://api.eqonaq.kz/api/v3/statistics/arrival-sheets_open?groupBy=citizenships.id&limit=10&orderBy[arrival_sheets_count]=desc&' +
              periodValue.value +
              '&accessCode=$2a$12$PL1zaxDuF9qCk8TUsuzSsu0I5nT7scDi0p2soiKR9aZs3JIL9B9Mi'
          )
          downloaded.value = true
          topCountry.value = response.data.data
        } catch (error) {
          console.error(error)
        }
      }
      function sortRegion(arr) {
        return arr
          .sort(
            (a, b) =>
              parseFloat(b.arrival_sheets_share) -
              parseFloat(a.arrival_sheets_share)
          )
          .slice(0, 10)
      }
      async function getTop10Regions() {
        try {
          downloaded.value = false
          const response = await axios.get(
            'https://api.eqonaq.kz/api/v3/statistics/arrival-sheets_open?groupBy=placements.region_id&orderBy[arrival_sheets_count]=desc&' +
              periodValue.value +
              '&accessCode=$2a$12$PL1zaxDuF9qCk8TUsuzSsu0I5nT7scDi0p2soiKR9aZs3JIL9B9Mi'
          )

          regionsData = []
          data.forEach((region) => {
            const findItem = response.data.data?.find(
              (c) => c.name_ru === region.name
            )
            let color
            let val = findItem?.arrival_sheets_count || 0
            if (val === 0) color = am4core.color('#DF767A')
            if (val < 50) color = am4core.color('#d4a53d')
            if (50 < val && val < 100) color = am4core.color('#62B9DF')
            if (100 < val) color = am4core.color('#00CAB4')

            regionsData.push({
              country_id: region.id,
              id: region.id,
              name: findItem?.name || region.name,
              name_kk: findItem?.name_kk || region.name,
              name_en: findItem?.name_en || region.name,
              value: findItem?.arrival_sheets_share || 0,
              count: findItem?.arrival_sheets_count || 0,
              fill: color
            })
          })

          topRegions.value = sortRegion(response.data.data || [])
          // getCountryGraphic()
          downloaded.value = true
        } catch (error) {
          console.error(error)
        }
      }
      async function getCountries() {
        try {
          downloaded.value = false
          const response = await axios.get(
            'https://api.eqonaq.kz/api/v1/stat/countries'
          )
          downloaded.value = true
          if (denIsActive.value === 'day') {
            allCountries.value = countriesDataList =
              response.data.top_ten_by_day
          } else if (denIsActive.value === 'week') {
            allCountries.value = countriesDataList =
              response.data.top_ten_by_week
          } else if (denIsActive.value === 'month') {
            allCountries.value = countriesDataList =
              response.data.top_ten_by_month
          } else if (denIsActive.value === 'year') {
            allCountries.value = countriesDataList =
              response.data.top_ten_by_year
          }
          allCountries.value = countriesDataList = countriesDataList.map(
            (item, itemInd) => {
              return {
                country_id: item.id || itemInd,
                id: item.id || itemInd,
                country: item,
                name: item.country_name_eng,
                country_name: item.country_name,
                country_name_eng: item.country_name_eng,
                country_name_kaz: item.country_name_kaz,
                name_ru: item.country_name,
                name_en: item.country_name_eng,
                name_kz: item.country_name_kaz,
                value: +item.percentage.replace(/[^0-9\.]/g, ''),
                flag: item.flag,
                fill: am4core.color(
                  `#${Math.floor(10777215 - Math.random() * 6000000).toString(
                    16
                  )}35`
                )
              }
            }
          )
          getWorldGraphic()
        } catch (error) {
          console.error(error)
        }
      }
      async function getTopHotels() {
        try {
          downloaded.value = false
          const response = await axios.get(
            'https://api.eqonaq.kz/api/v3/statistics/arrival-sheets_open?groupBy=placements.id&orderBy[arrival_sheets_count]=desc&limit=10&' +
              periodValue.value +
              '&accessCode=$2a$12$PL1zaxDuF9qCk8TUsuzSsu0I5nT7scDi0p2soiKR9aZs3JIL9B9Mi'
          )
          downloaded.value = true
          topHotel.value = response.data.data
        } catch (error) {
          console.error(error)
        }
      }
      async function getTargets() {
        try {
          downloaded.value = false
          const response = await axios.get(
            'https://api.eqonaq.kz/api/v3/statistics/arrival-sheets_open?orderBy[arrival_sheets_count]=desc&groupBy=purpose_of_visits.id&' +
              periodValue.value +
              '&accessCode=$2a$12$PL1zaxDuF9qCk8TUsuzSsu0I5nT7scDi0p2soiKR9aZs3JIL9B9Mi'
          )
          downloaded.value = true

          countVisit.value = response.data.data
        } catch (error) {
          console.error(error)
        }
      }
      let array
      async function getEqonaq() {
        getCountries()
        getTopCountries()
        getTop10Regions()

        getTopHotels()
        getTargets()
        getGenders()
        getAgeGroups()
      }
      getEqonaq()
      async function getGenders() {
        try {
          downloaded.value = false

          let value
          const response = await axios.get(
            'https://api.eqonaq.kz/api/v3/statistics/arrival-sheets_open?groupBy=gender_id&' +
              periodValue.value +
              '&accessCode=$2a$12$PL1zaxDuF9qCk8TUsuzSsu0I5nT7scDi0p2soiKR9aZs3JIL9B9Mi'
          )
          value = response.data.data

          let genderValues = []
          value = value.forEach((element) => {
            genderValues.push(element.arrival_sheet_share)
          })
          woman.value = Math.round(genderValues[0] / 10)
          man.value = Math.round(genderValues[1] / 10)

          for (let i = 0; i < 10; i++) {
            if (man.value > i) {
              manArray.value.push('#00ead0')
            } else manArray.value.push('rgba(103, 109, 115, 0.15)')
            if (woman.value > i) {
              womanArray.value.push('rgb(255, 41, 71)')
            } else womanArray.value.push('rgba(103, 109, 115, 0.15)')
          }

          genderValue.value = genderValues
          downloaded.value = true
        } catch (error) {
          console.error(error)
        }
      }
      async function getAgeGroups() {
        try {
          let data
          const response = await axios.get(
            'https://api.eqonaq.kz/api/v3/statistics/arrival-sheets_open?groupBy=date_birth&group%5B0%5D%5Bstart%5D=0&group%5B0%5D%5Bend%5D=18&group%5B1%5D%5Bstart%5D=19&group%5B1%5D%5Bend%5D=25&group%5B2%5D%5Bstart%5D=26&group%5B2%5D%5Bend%5D=35&group%5B3%5D%5Bstart%5D=36&group%5B3%5D%5Bend%5D=45&group%5B4%5D%5Bstart%5D=46&group%5B4%5D%5Bend%5D=55&group%5B5%5D%5Bstart%5D=56&group%5B5%5D%5Bend%5D=84&' +
              periodValue.value +
              '&accessCode=$2a$12$PL1zaxDuF9qCk8TUsuzSsu0I5nT7scDi0p2soiKR9aZs3JIL9B9Mi'
          )
          data = Object.values(response.data?.data).sort(
            (a, b) => a?.age?.split(' ')[0] - b?.age?.split(' ')[0]
          )
          pieGtraphics.data = data.map((item) => {
            return {
              country: item.age,
              value: item.arrival_sheets_share
            }
          })
          data[data.length - 1].age = ''
          dataToLegend.value = data
        } catch (error) {}
      }
      function getAgeRangeTranslate(length, ind) {
        if (ind + 1 === length) return 'labels.ageRest'
        return 'labels.ageYears'
      }
      function getHintName(target) {
        return target[targetTranslates[i18n.locale.value]]
      }
      function getCountryName(country) {
        return country[countriesTranslates[i18n.locale.value]]
      }
      function getRegionName(country) {
        return country[regionsTranslates[i18n.locale.value]]
      }

      return {
        period,
        quater,
        mouseCoords,
        hoveredRegion,
        getRegionFillColor,
        mouseover,
        getRegionName,
        getCountryName,
        getAgeRangeTranslate,
        getHintName,
        message,
        pageStyle,
        darkStyle,
        pieGtraphics,
        dataToLegend,
        totalValue,
        round,
        denIsActive,
        dateDay,
        changeDate,
        dateMes,
        dateWeek,
        dateYear,
        genderValue,
        woman,
        man,
        manArray,
        womanArray,
        downloaded,
        countVisit,
        totalCountVisit,
        topCountry,
        topRegions,
        topHotel,
        allCountries
      }
    }
  })
</script>

<style lang="scss" scoped>
  .top-line {
    margin-bottom: 0 !important;
  }

  .main {
    background-color: #f4f4f4;
    min-height: 100vh;

    padding-top: 24px;
    padding-bottom: 90px;
  }

  .bread_crumbs {
    display: flex;
    margin-bottom: 15px;

    & * {
      color: #676d73;
      font-size: 14px;
      font-weight: 300;
      text-decoration: none;
    }

    & a:hover {
      text-decoration: underline;
    }

    & li {
      margin-right: 20px;
    }
  }

  .section .col {
    position: relative;
  }

  .section__title {
    font-size: 24px;
    font-weight: 600;

    display: flex;
    align-items: center;
  }

  .section__subTitle {
    display: block;
    width: 70%;

    color: #676d73;
    font-size: 14px;
    line-height: 1.2;
    font-weight: 500;
  }

  .touchBord {
    &-switchBtn {
      display: flex;
      overflow: hidden;
      border-radius: 6px;
    }

    &-btn {
      color: rgba(#676d73, 0.4);
      font-size: 16px;
      line-height: 26px;
      text-decoration: none;

      padding: 8px 26px;
      background-color: rgba(#676d73, 0.1);
      transition: color 0.2s linear;

      &:hover {
        color: rgba(#16355b, 0.8);
      }
    }

    &-btn.act {
      color: #fff;
      background-color: #16355b;
    }

    &-date {
      position: relative;
      margin-right: 30px;

      &:hover {
        & .touchBord-option {
          opacity: 1;
          visibility: visible;
        }
      }

      & .touchBord-option {
        position: absolute;
        z-index: 2;
        width: 100%;

        opacity: 0;
        visibility: hidden;

        transition: opacity 0.2s linear, visibility 0.2s linear,
          color 0.2s linear, background-color 0.2s linear;

        button {
          font-family: 'Museo Sans Cyrl';
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          text-align: left;
          line-height: 26px;
          width: 100%;
          background-color: #fff;
          border: none;
          border-radius: 6px;
          color: #16355b;
          padding: 8px 15px;
          margin-top: 4px;
          box-shadow: 0px 4px 10px rgb(0 0 0 / 25%);

          &:hover {
            color: #fff;
            background-color: #16355b;
          }
        }
      }
    }

    &-select {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 150px;
      color: #16355b;
      font-size: 16px;
      line-height: 26px;
      padding: 8px 15px;

      cursor: pointer;

      border-radius: 6px;
      border: 0.5px solid #676d73;
      background-color: #fff;

      & svg {
        color: #ca9e67;
        width: 10px;
        height: 10px;
      }
    }
  }

  .colorDescriptions {
    position: absolute;
    bottom: 0;
    left: 14px;
    z-index: 2;

    & li {
      display: flex;
      align-items: center;
      margin-bottom: 7px;
    }

    & li:nth-child(1) {
      & .colorDescriptions-colorBlock {
        background-color: #df767a;
      }
    }

    & li:nth-child(2) {
      & .colorDescriptions-colorBlock {
        background-color: #d4a53d;
      }
    }

    & li:nth-child(3) {
      & .colorDescriptions-colorBlock {
        background-color: #62b9df;
      }
    }

    &-colorBlock {
      width: 25px;
      height: 10px;
      margin-right: 17px;

      background-color: #00cab4;
    }

    &-num {
      color: #16355b;

      font-size: 18px;
      line-height: 22px;
    }

    & span {
      color: #8595a8;
    }
  }

  .task-name12 {
    display: inline-flex;
    align-items: center;
    margin-top: 90px;
    font-size: 24px;
    font-weight: 600;
    line-height: 23px;
    color: #16355b;
    text-transform: none;

    position: relative;
  }

  .hint {
    cursor: help;

    display: flex;
    align-items: center;

    position: relative;

    border: none;
    background-color: transparent;

    margin-left: 10px;

    & svg {
      width: 20px;
      height: 20px;
      fill: #c4c4c4;
    }

    &-content {
      display: inline-flex;
      align-items: center;
      width: 380px;

      color: #fff;
      font-size: 12px;
      line-height: 1.2;
      text-align: left;

      opacity: 0;
      visibility: hidden;

      position: absolute;
      bottom: 35px;
      left: -4px;

      padding: 10px 15px;

      border-radius: 10px;
      background-color: #c4c4c4;

      transition: opacity 0.2s linear, visibility 0.2s linear;
    }

    &:hover .hint-content,
    &:focus .hint-content {
      opacity: 1;
      visibility: visible;
    }
  }

  .intro_titleTop {
    margin-bottom: 27px;
  }

  .intro_item {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-bottom: 14px;
  }

  .intro_titleBottom {
    display: flex;
    align-items: center;
    margin-bottom: 38px;
  }

  .switch_btn {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    padding: 10px 23px;
    cursor: pointer;

    border: 0;
    border-radius: 100px;
    background-color: #ca9e67;

    transition: background-color 0.2s linear;

    &:hover {
      background-color: #16355b;
    }
  }

  .chartdiv {
    background: transparent;
    box-shadow: none;
    display: flex;
    justify-content: center;

    path {
      cursor: pointer;
    }
  }

  .wordMap {
    position: relative;
    padding-bottom: 52%;
    margin-top: 40px;
  }

  .chartdiv2 {
    position: absolute;
    height: 100%;
    width: 100%;
  }

  .divchartpie {
    height: 100%;
    width: 100%;
  }

  .touch-board-countries {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 18px;

    font-weight: 300;
    font-size: 18px;
    line-height: 30px;
    color: #394048;

    margin-top: 40px;

    & p {
      margin-bottom: 16px;
    }

    & > * {
      margin-bottom: 20px;
    }

    &-item {
      display: flex;
      align-items: center;

      padding: 14px 13px;
      background-color: #fff;
      margin-bottom: 0;

      &--region {
        img {
          height: 33px !important;
        }
      }
    }

    & img {
      display: block;
      width: 33px;
      height: 22px;
      margin-right: 12px;
    }

    & .name {
      font-size: 18px;
      font-weight: 600;
      line-height: 1.4;
      color: #16355b;
      margin-bottom: 0;
    }

    & .quantity {
      color: rgba(#676d73, 0.7);
      font-size: 14px;
      font-weight: 600;
      line-height: 1.4;
      margin: 0;
    }
  }

  .portraitTourist {
    margin-top: 40px;

    &-block {
      height: 334px;
      padding: 20px 25px;

      border-radius: 6px;
      background-color: #fff;
    }

    & .col-6:nth-child(2) {
      & .portraitTourist-block {
        padding: 20px 52px 20px 25px;
      }
    }

    &-item.man {
      .portraitTourist-human {
        & svg {
          fill: #00ead0;
        }
      }

      .portraitTourist-previews {
        & svg:nth-child(-n + 4) {
          fill: #00ead0;
        }
      }
    }

    &-item.woman {
      .portraitTourist-human {
        & svg {
          fill: #ff2947;
        }
      }

      .portraitTourist-previews {
        & svg:nth-child(-n + 6) {
          fill: #ff2947;
        }
      }
    }

    &-title {
      color: #16355b;
      font-size: 18px;
      font-weight: 600;
      line-height: 1.7;
      margin-bottom: 15px;
    }

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
    }

    &-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      padding: 8px 12px;
      margin-right: 25px;

      border-radius: 3px;
    }

    &-name {
      color: rgba(#676d73, 0.5);
      font-size: 12px;
      line-height: 1.2;
    }

    &-human {
      margin-bottom: 9px;
      margin-top: 9px;

      & svg {
        display: block;
        height: 45px;
        fill: rgba(#676d73, 0.15);
      }
    }

    &-quantity {
      color: #676d73;
      font-size: 18px;
      font-weight: 600;
      line-height: 1.2;
    }

    &-previews {
      width: 82%;
      max-width: 82%;
      display: flex;
      justify-content: space-between;
      padding-right: 5px;

      & svg {
        display: block;
        height: 65.36px;
        width: auto;
        fill: rgba(#676d73, 0.15);
        margin-right: 10px;
      }

      & svg:last-child {
        margin-right: 0;
      }
    }

    &-graphic {
      height: 100%;

      display: flex;
      justify-content: space-between;

      & .divchartpie {
        height: 100%;
        width: 100%;
      }
    }

    &-graphicPie {
      height: 260px;
      width: 260px;
      max-height: 100%;
      max-width: 48%;
    }
  }

  .Pielegend {
    &-items {
      width: 50%;
      height: 100%;
      padding-left: 44px;

      & .Pielegend-item:nth-child(1) {
        & .Pielegend-marker {
          background-color: #0194eb;
        }
      }

      & .Pielegend-item:nth-child(2) {
        & .Pielegend-marker {
          background-color: #fb8832;
        }
      }

      & .Pielegend-item:nth-child(3) {
        & .Pielegend-marker {
          background-color: #944cee;
        }
      }

      & .Pielegend-item:nth-child(4) {
        & .Pielegend-marker {
          background-color: #55dce7;
        }
      }

      & .Pielegend-item:nth-child(5) {
        & .Pielegend-marker {
          background-color: #2ffc8d;
        }
      }

      & .Pielegend-item:nth-child(6) {
        & .Pielegend-marker {
          background-color: #fc2f2f;
        }
      }
    }

    &-item {
      width: 100%;
      display: flex;
      justify-content: space-between;

      margin-bottom: 12px;
    }

    &-title,
    &-quantity {
      color: #676d73;
      font-size: 16px;
    }

    &-title {
      display: flex;
      align-items: center;
    }

    &-marker {
      width: 8px;
      height: 8px;

      border-radius: 12px;
      background-color: #000;

      margin-right: 19px;
    }
  }

  .purposeVisits {
    padding: 14px 15px;

    border-radius: 6px;
    background-color: #fff;

    margin-top: 40px;

    & .row {
      padding: 40px 0;
    }

    &-info {
      padding: 0 25px;
      margin-bottom: 20px;
    }

    & .col-6:nth-child(2) {
      & .purposeVisits-graphics span {
        background-color: #0dba55;
      }
    }

    & .col-6:nth-child(3) {
      & .purposeVisits-graphics span {
        width: 21.6%;
        background-color: #3dc4c3;
      }
    }

    & .col-6:nth-child(4) {
      & .purposeVisits-graphics span {
        width: 21.6%;
        background-color: #efc42d;
      }
    }

    & .col-6:nth-child(5) {
      & .purposeVisits-graphics span {
        width: 15.5%;
        background-color: #fd582d;
      }
    }

    & .col-6:nth-child(6) {
      & .purposeVisits-graphics span {
        width: 15.5%;
        background-color: #d87598;
      }
    }

    & .col-6:nth-child(7) {
      & .purposeVisits-graphics span {
        width: 12.3%;
        background-color: #0173e2;
      }
    }

    & .col-6:nth-child(8) {
      & .purposeVisits-graphics span {
        width: 12.3%;
        background-color: #00bfaa;
      }
    }

    &-content {
      display: flex;

      justify-content: space-between;
      margin-bottom: 6px;
    }

    &-name {
      color: #676d73;
      font-size: 16px;
      font-weight: 400;
      font-family: 'Museo Sans Cyrl';
      line-height: 1.8;
    }

    &-quantity {
      color: #676d73;
      font-size: 16px;
      font-weight: 400;
      font-family: 'Museo Sans Cyrl';
      line-height: 1.8;
    }

    &-graphics {
      height: 3px;
      width: 100%;

      position: relative;

      background-color: rgba(#676d73, 0.15);

      & span {
        display: block;

        height: 7px;
        width: 38.5%;

        position: absolute;
        top: 50%;
        right: 0;
        z-index: 1;
        transform: translate3d(0, -50%, 0);

        border-radius: 10px;
        background-color: #7929dd;
      }
    }
  }

  .hotels {
    height: 334px;

    display: flex;
    flex-wrap: wrap;
    margin-top: 40px;
    border-collapse: collapse;
    grid-gap: 8px 0;
    margin-bottom: 80px;

    &-col {
      width: 20%;
      height: auto;

      & .hotels-hotel {
        height: 100%;
      }

      &-preview {
        margin-bottom: 5px;
      }
    }

    &-hotel {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      box-sizing: border-box;

      padding: 14px 10px;
      border: 3px solid #f4f4f4;
      border-collapse: collapse;

      background-color: #fff;

      & img {
        display: flex;
        max-width: 40%;
        margin: auto;
      }
    }

    &-preview {
      margin-bottom: 5px;
    }

    &-content {
      width: 100%;
      text-align: center;
    }

    & .name {
      color: #676d73;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.2;

      margin-bottom: 5px;
    }

    & .quantity {
      color: rgba(#676d73, 0.5);
      font-size: 14px;
      font-weight: 400;
      line-height: 1.2;
    }
  }

  .dark {
    background-color: #16355b;
    border-bottom: #ca9e67 1px solid;

    .bread_crumbs {
      & * {
        color: rgba(#ffffff, 0.5);
      }
    }

    .section__subTitle,
    .section__title {
      color: rgba(#fff, 0.8);
    }

    .touchBord {
      &-btn {
        color: rgba(#fff, 0.3);
        background-color: rgba(#f4f4f4, 0.1);

        &:hover {
          color: rgba(#f4f4f4, 0.25);
        }
      }

      &-btn.act {
        color: #fff;
        background-color: rgba(#f4f4f4, 0.4);
      }
    }

    .numberTourists {
      &-num {
        color: #fff;
      }

      &-text {
        color: #fff;
      }
    }

    .colorDescriptions {
      &-num {
        color: #fff;
      }

      & span {
        color: #8595a8;
      }
    }

    .task-name12 {
      color: rgba(#fff, 0.8);
    }

    .hint {
      & svg {
        fill: rgba(#f4f4f4, 0.3);
      }

      &-content {
        background-color: rgba(#f4f4f4, 0.3);
      }
    }

    .switch_btn {
      &:hover {
        background-color: rgba(#ca9e67, 0.7);
      }
    }

    .touchBord-option {
      &:hover {
        background-color: #ca9e67;
      }
    }

    .touch-board-countries {
      &-item {
        background-color: rgba(#f4f4f4, 0.1);
      }

      & .name {
        color: #fff;
      }

      & .quantity {
        color: rgba(#fff, 0.5);
        margin-bottom: 0;
      }
    }

    .portraitTourist {
      &-block {
        background-color: rgba(#f4f4f4, 0.1);
      }

      &-block:last-child {
        & .portraitTourist-content {
          background-color: transparent;
        }
      }

      &-title {
        color: #fff;
      }

      &-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
      }

      &-content {
        background-color: rgba(#f4f4f4, 0.1);
      }

      &-name {
        color: rgba(#ffffff, 0.5);
      }

      &-human {
        & svg {
          display: block;
          height: 45px;
          fill: rgba(#f4f4f4, 0.1);
        }
      }

      &-quantity {
        color: #fff;
      }

      &-previews {
        & svg {
          fill: rgba(#f4f4f4, 0.1);
        }
      }
    }

    .purposeVisits {
      background-color: rgba(#f4f4f4, 0.1);

      &-name {
        color: #fff;
      }

      &-quantity {
        color: #fff;
      }

      &-graphics {
        background-color: rgba(#f4f4f4, 0.1);
      }
    }

    .hotels {
      &-hotel {
        border-color: #16355b;
        background-color: rgba(#f4f4f4, 0.1);
      }

      & .name {
        color: #fff;
      }

      & .quantity {
        color: rgba(#fff, 0.5);
      }
    }

    .Pielegend {
      &-title,
      &-quantity {
        color: #fff;
      }
    }
  }

  .hovered-region {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    background: #fff;
    padding: 5px 10px;
    border: 1px solid #000;
    font-size: 16px;
    pointer-events: none;
  }
</style>
